<bit-accordion [title]="title()" [subtitle]="subtitle()" [startIcon]="startIcon()" [(open)]="open">
  @if (tasks().length > 0) {
    <bit-badge variant="primary" startIcon="bwi-clock" slot="end">
      {{ "onboardingTasksComplete" | i18n: amountCompleted() : tasks().length }}
    </bit-badge>
  } @else {
    <bit-icon name="bwi-spinner" class="bwi-spin" slot="end"></bit-icon>
  }

  <div class="tw-flex tw-flex-col" role="list">
    <ng-content></ng-content>
  </div>

  <div class="tw-pt-4 tw-text-center">
    <button bitButton buttonType="subtleGhost" size="small" type="button" (click)="dismiss.emit()">
      {{ "dismissThisChecklist" | i18n }}
    </button>
  </div>
</bit-accordion>
